import { getAllProducts } from "@/services/pricing-config.service";
import { useQuery } from "@tanstack/react-query";

export const useAllProducts = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  return useQuery({
    queryKey: ["all-products", params.page, params.size, params.search],
    queryFn: () => getAllProducts(params),
    enabled,
    ...options,
  });
};
